import React from "react";

function InsuranceIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <g clip-path="url(#clip0_1388_2209)">
        <path
          d="M8.18751 0C8.33126 0 8.47501 0.03125 8.60626 0.090625L14.4906 2.5875C15.1781 2.87813 15.6906 3.55625 15.6875 4.375C15.6719 7.475 14.3969 13.1469 9.01251 15.725C8.49064 15.975 7.88439 15.975 7.36251 15.725C1.97814 13.1469 0.703139 7.475 0.687514 4.375C0.684389 3.55625 1.19689 2.87813 1.88439 2.5875L7.77189 0.090625C7.90001 0.03125 8.04376 0 8.18751 0ZM8.18751 2.0875V13.9C12.5 11.8125 13.6594 7.19062 13.6875 4.41875L8.18751 2.0875Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1388_2209">
          <path d="M0.1875 0H16.1875V16H0.1875V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default InsuranceIcon;
